export { Caption1 } from './Caption1';
export { caption1ClassNames } from './useCaption1Styles.styles';
